<!-- Personel Shell: Router Outlet -->
<div class="aktif-icerik aktif-enter">
  <div class="pano-aktif" fikoBounceScroll>
    <router-outlet></router-outlet>
  </div>
</div>
